import Head from 'next/head';

import AdminLandingPage from '../../components/AdminComp/AdminLandingPage';
import { pageTitle } from '../../components/shared/basic/customHead';

const SuperAdminPage = () => {
  return (
    <div>
      <Head>
        <title>{pageTitle('Super Admin')}</title>
      </Head>
      <AdminLandingPage />
    </div>
  );
};

export default SuperAdminPage;
